import useReveal from '../../hooks/useReveal';
import { COOWN_SUPPORT_EMAIL } from '../../config/constants';
import { scrollPageToTop } from '../../utils/properties';

const HomeJourneyCtaSection = ({ setPage, isLoggedIn }) => {
  const [ref, visible] = useReveal();

  const handleCreateAccount = (e) => {
    e.preventDefault();
    scrollPageToTop();
    setPage?.(isLoggedIn ? 'dashboard' : 'register');
  };

  const handleScheduleCall = (e) => {
    e.preventDefault();
    window.location.href = `mailto:${COOWN_SUPPORT_EMAIL}?subject=${encodeURIComponent('Schedule a CoOwn consultation')}`;
  };

  return (
    <section
      ref={ref}
      className="home-journey-cta"
      aria-labelledby="home-journey-heading"
    >
      <div className="home-journey-cta-inner">
        <div className={`reveal-up ${visible ? 'visible' : ''} home-process-eyebrow`}>
          <div className="home-process-eyebrow-line" aria-hidden="true"></div>
          <span className="home-process-eyebrow-text">Begin your journey</span>
          <div className="home-process-eyebrow-line home-process-eyebrow-line--reverse" aria-hidden="true"></div>
        </div>

        <h2
          id="home-journey-heading"
          className={`reveal-up delay-1 ${visible ? 'visible' : ''} home-journey-cta-title`}
        >
          Start Building Your <em>Portfolio</em>
          <span className="home-journey-cta-title-dot" aria-hidden="true"></span>
          Today
        </h2>

        <p className={`reveal-up delay-2 ${visible ? 'visible' : ''} home-journey-cta-lead`}>
          Join thousands of investors who are already diversifying into premium real estate.
          Your first share is just a few clicks away.
        </p>

        <div className={`reveal-up delay-3 ${visible ? 'visible' : ''} home-journey-cta-actions`}>
          <button type="button" className="btn btn-primary home-journey-cta-btn" onClick={handleCreateAccount}>
            Create Free Account
          </button>
          <button type="button" className="btn home-journey-cta-btn home-journey-cta-btn-secondary" onClick={handleScheduleCall}>
            Schedule a Call
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeJourneyCtaSection;
